import { jsonGet, jsonPost, jsonPut } from "../api";

/**
 * The objective endpoints.
 *
 * Note `fetchActiveObjective` answers 204 when the brand has no running objective, which api.js
 * resolves to `{}` — so callers must test for real content (`objective?.title`) rather than
 * truthiness, exactly as the digest widget has to.
 */

export const fetchActiveObjective = async (brandId) =>
  await jsonGet(`brands/${brandId}/objectives/active`);

export const fetchObjectiveMentionContext = async (brandId) =>
  await jsonGet(`brands/${brandId}/objectives/active/mention-context`);

export const fetchObjectiveHistory = async (brandId) =>
  await jsonGet(`brands/${brandId}/objectives`);

export const fetchObjectiveMetrics = async (brandId) =>
  await jsonGet(`brands/${brandId}/objectives/metrics`);

export const proposeObjectives = async (brandId) =>
  await jsonPost(`brands/${brandId}/objectives/proposals`, {});

export const createObjective = async (brandId, dto) =>
  await jsonPost(`brands/${brandId}/objectives`, dto);

export const updateObjective = async (brandId, objectiveId, dto) =>
  await jsonPut(`brands/${brandId}/objectives/${objectiveId}`, dto);

export const activateObjective = async (brandId, objectiveId) =>
  await jsonPost(`brands/${brandId}/objectives/${objectiveId}/activation`, {});

export const closeObjective = async (brandId, objectiveId, outcome, note) =>
  await jsonPost(`brands/${brandId}/objectives/${objectiveId}/outcome`, { outcome, note });
